import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { CarForm } from './CarForm';
import { SEO } from './SEO';
import { services, ServiceType } from '../routes/seoRoutes';
import { Hero } from './Hero';
import { WhyChooseUs } from './WhyChooseUs';

interface ServicePageProps {
  service: ServiceType;
  city: string;
}

export const ServicePage: React.FC<ServicePageProps> = ({ service }) => {
  const { city: urlCity } = useParams<{ city: string }>();
  const location = useLocation();
  const serviceConfig = services[service];

  React.useEffect(() => {
    console.log('ServicePage Params:', { service, city: urlCity, path: location.pathname });
  }, [service, urlCity, location]);

  if (!urlCity) {
    return null;
  }

  const getServiceContent = (service: ServiceType, city: string) => {
    switch (service) {
      case 'value-your-car':
        return {
          title: `Car Valuation Service in ${city}`,
          description: `Get an instant professional valuation for your car in ${city}. Fast, reliable, and stress-free service.`
        };
      
      case 'sell-your-car':
        return {
          title: `Sell Your Car Service in ${city}`,
          description: `Get the best price for your car in ${city} with our professional car buying service. Fast and hassle-free.`
        };

      case 'instant-car-purchase':
        return {
          title: `Instant Car Purchase Service in ${city}`,
          description: `We buy your car instantly in ${city} with same-day payment and free pickup. Get the best market price.`
        };

      case 'car-inspection':
        return {
          title: `Pre-Purchase Inspection Service in ${city}`,
          description: `Professional vehicle inspection service in ${city} before we purchase your car. Thorough and reliable.`
        };

      case 'car-valuation':
        return {
          title: `Professional Car Valuation Service in ${city}`,
          description: `Get an accurate market value for your vehicle in ${city} from our experienced automotive experts.`
        };

      case 'sell-car-now':
        return {
          title: `Sell Car Now Service in ${city}`,
          description: `Quick and hassle-free car selling process in ${city} with instant payment. Get the best price today.`
        };

      default:
        return {
          title: `${serviceConfig.title} Service in ${city}`,
          description: `${serviceConfig.description} in ${city}. Fast and professional service.`
        };
    }
  };

  const pageContent = getServiceContent(service, urlCity);

  return (
    <>
      <SEO
        title={pageContent.title}
        description={pageContent.description}
        path={`/${serviceConfig.path}-${urlCity.toLowerCase()}`}
        city={urlCity}
        service={serviceConfig.title}
      />
      
      <Hero service={service} city={urlCity} />
      <WhyChooseUs />
    </>
  );
}; 